<template>
    <textarea
        rows="5"
        :value="value"
        @input="onChange"
    ></textarea>
</template>

<script lang="ts" setup>
const modelValue = defineModel();
defineProps<{
  value?: string | number
}>();
const onChange = (e: Event) => {
  modelValue.value = e.target?.value;
};
</script>
